import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { removeParameters } from '@/app/common/urlParametersUtils.ts';

type CreateSearchParamsHotelFilterProps = {
  searchParams: SearchParams;
  appliedFilters: SearchParams;
};
// When the Hotel Name filter is applied, we remove the Map Area parameter
export const createSearchParamsAccommodationFilter = ({
  searchParams,
  appliedFilters,
}: CreateSearchParamsHotelFilterProps): SearchParams =>
  (appliedFilters || {})[URLParameters.ACCOMODATION_NAME]
    ? removeParameters(searchParams, [URLParameters.MAP_AREA])
    : searchParams;
